/* global Loader:true $:true Foundation:true Flickity:true */
//import 'babel-polyfill';

import debug from "debug";
import debounce from '../../lib/debounce';
jQueryBridget('flickity', Flickity, $);

window.Symbol = Symbol;
const ONE = 1;
const ZERO = 0;
const MODULE_NAME = 'module/block-gallery';
const log = debug(MODULE_NAME);
const userAgentContains = (str) => navigator.userAgent.toLowerCase().indexOf(str.toLowerCase()) > -1;
const UA_HAS_SAFARI = userAgentContains("Safari");
const UA_HAS_CHROME = userAgentContains("Crhome");
const UA_HAS_OPERA = userAgentContains("op");
const UA_IS_SAFARI = UA_HAS_SAFARI && !UA_HAS_CHROME;
const UA_IS_CHROME = UA_HAS_CHROME && !UA_HAS_OPERA;

export class ImageGalleryComponent {

    constructor (element, options) {
        this.element = element;
        this.$element = $(element);
        this.options = options;
        this.options.nextKeyCodes = this.options.nextKeyCodes.replace(' ', '').split(',') || [];
        this.options.previousKeyCodes = this.options.previousKeyCodes.replace(' ', '').split(',') || [];
        this.SHIFT_PRESSED = false;

        this.$thumbnails = this.$element.find(this.options.thumbnailsContainerSelector);
		this.$main = this.$element.find(this.options.mainContainerSelector);
		this.$modalButtons = this.$element.find(this.options.modalButtonSelector);

        this.element.component = this;
        log('constructed', this.element);

		this.init();
		this.watch();
    }

    watch () {
        // window.addEventListener('resize',
        //     debounce(this.init.bind(this), 150));
		// log('watching', this.element);

		this.$modalButtons.on('click', this.openModal.bind(this));

    }
    /**
     * // 1. trigger redraw for transition
     */
    init () {
        const element = this.element;
        let thumbSlider;
        let mainSlider;

        const main = this.$main.get(0);
        this.$main.removeClass(this.options.mainContainerHiddenClass);
        main.offsetHeight; // 1

        if (Foundation.MediaQuery.current === 'small') {
            this.mainSlider = new Flickity(main, {
                pageDots: true,
                setGallerySize: true,
                prevNextButtons: false,
                autoPlay : this.options.autoplay
            });

            log('initalised.smallScreens', element);

        }

        if (Foundation.MediaQuery.atLeast('medium')) {

            const thumbs = this.$thumbnails.get(0);
            this.$thumbnails.removeClass(this.options.thumbnailsContainerHiddenClass);
            thumbs.offsetHeight; // 1

            mainSlider = new Flickity(main, {
                pageDots: true,
                draggable: false,
                setGallerySize: true,
                prevNextButtons: false
            });

            thumbSlider = new Flickity(thumbs, {
                adaptiveHeight: false,
                setGallerySize: false,
                // asNavFor: main,
                pageDots: false,
                contain: true,
                arrowShape: this.options.arrowShape,
                autoPlay : this.options.autoplay
            });

            thumbSlider.on('select', this.onSelect.bind(this));
            this.$thumbnails.on('click', 'button', this.onCellClick.bind(this));

            log('initalised.mediumUpScreens', this.element);
        }
        this.mainSlider = mainSlider;
        this.thumbSlider = thumbSlider;
    }

    onCellClick (event) {
        const {currentTarget} = event;
        const selected = this.$thumbnails.find('button').index(currentTarget);
        log('onCellClick', {currentTarget, selected});
        this.thumbSlider.select(selected);
    }

    onSelect (index) {
        log('onSelect', index);

        const selected = this.$thumbnails.find('.is-selected');
            //   selected.focus();

        this.mainSlider.select(selected.index());

	}

	openModal (event) {
		const modalId = $(event.currentTarget).attr('data-reveal-id');
		$('#' + modalId).foundation('open');
	}


}

ImageGalleryComponent.DEFAULTS = {
    mainContainerSelector: '.image-gallery__main-container',
    mainContainerHiddenClass: 'block-image-gallery__main--is-hidden',
    thumbnailsContainerSelector: '.image-gallery__thumbnails-container',
    thumbnailsItemSelector: '.image-gallery__thumbnail-item',
    thumbnailsContainerHiddenClass: 'block-image-gallery__thumbnails-container--is-hidden',
    nextKeyCodes: '39, 40', // right or down
    previousKeyCodes: '37, 48', // left or up
    // https://flickity.metafizzy.co/options.html#arrowshape
    arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
    }
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/image-gallery/component.js